/**
 * Retrieve the Phone Number that is ready to set in the widget.
 * @param {string} mobileNumber
 */
function getMobileNumberForWidget(mobileNumber) {
    if (isNaN(mobileNumber)) return '';

    if (mobileNumber.length === 11) {
        // remove MSISDN fix
        return mobileNumber.substring(2, mobileNumber.length);
    }

    if (mobileNumber.length === 10) {
        // remove leading zero
        return mobileNumber.substring(1, mobileNumber.length);
    }

    return mobileNumber;
}

/**
 * Retrieve the Phone Number from the Widget.
 * @param {string} phoneNumber
 */
function getPrePolulatedPhoneNumberFromWidget(phoneNumber) {
    const dataString = localStorage.getItem(`ringcaptcha.widget.${phoneNumber}`);
    const data = dataString ? JSON.parse(dataString) : null;
    if (!data && !data.phoneNumber) {
        const phone = `${data.phoneNumber.substring(3, data.phoneNumber.length)}`;
        return phone;
    }
    return '';
}

/**
 * Actions to perform when RingCaptcha widget is ready.
 * @param {string} key
 * @param {string} scope
 */
function onWidgetReady(key, phoneNumber) {
    // Overriding the ghost text inside the mobile number text box
    $('input[type=tel]').attr('placeholder', '');
    // Handle desktop version
    $('.country-list a').click(() => {
        setInterval(() => {
            $('input[type=tel]').attr('placeholder', '');
        }, 5);
    });
    // Handle mobile version
    $('.country-list-mobile').click(() => {
        setInterval(() => {
            $('input[type=tel]').attr('placeholder', '');
        }, 5);
    });

    // when going back to cart and do some changes, and come back to checkout panel, scope.phoneNumber become undefined randomly.
    // but since the widget is already loaded with the mobile number, mobile number is read from the Widget
    if (!phoneNumber) {
        const phoneNumberForWidget = getMobileNumberForWidget(getPrePolulatedPhoneNumberFromWidget(key));
        $('input.form-control.phone-input.phone-input-verify').val(phoneNumberForWidget);
    } else {
        // parsing the shopper mobile number in to the widget
        const phoneNumberForWidget = getMobileNumberForWidget(phoneNumber);
        $('input.form-control.phone-input.phone-input-verify').val(phoneNumberForWidget);
    }
    $(this).off('click', '.country-button');
}

/**
 * Load the Ring Captcha widget.
 * @param {object} scope Directive scope.
 * @param {object} settings Frontend settings
 */
function loadWidget(scope, settings) {
    // We have to disable linting as we can't workaround using the widget.
    // eslint-disable-next-line
    new RingCaptcha.Widget('#ring-captcha', {
        app: settings.ringCaptchaMessages.ringCaptchaAppKey,
        events: {
            ready: () => {
                onWidgetReady(settings.ringCaptchaMessages.ringCaptchaAppKey, scope.phoneNumber);
            },
            verified: () => {
                // extracting the phone number validated by the widget
                const dataString = localStorage.getItem(`ringcaptcha.widget.${settings.ringCaptchaMessages.ringCaptchaAppKey}`);
                const data = dataString ? JSON.parse(dataString) : null;
                const phone = `0${data.phoneNumber.substring(3, data.phoneNumber.length)}`;
                // extracting token
                const tokenAssigned = data.token;
                // Gets the hidden input value with name = 'ringcaptcha_pin_code'
                const code = $('input[name="ringcaptcha_pin_code"]').val();

                scope.onVerification({
                    verifiedPhoneNumber: phone, token: tokenAssigned, otpCode: code,
                });
                scope.$apply();
            },

            // Trigger the session expired message
            error: (event) => {
                if (event.type === 'error' && (event.error === 'session_expired' || event.error === 'invalid_session')) {
                    scope.onSessionTimeOut();
                    scope.$apply();
                }
            },

            // display error message when number of tries to enter PIN is exceeded.
            max_validations: () => {
                scope.onExceedMaximumRetries();
                scope.$apply();
            },
        },
    });
}

module.exports = function (settings, $window, resourceInjector) {
    $window.RingCaptchaLocale = {
        en: {
            'code.title': '',
            'code.service.sms.summary': settings.ringCaptchaMessages.smsNotificationSummaryText,
            'code.service.sms.label': settings.ringCaptchaMessages.sendSmsButtonLabel,
            'check.title.sms': settings.ringCaptchaMessages.sendSmsCheckPinCodeLabel,
            'check.retry': settings.ringCaptchaMessages.tryAgainLinkText,
            'code.summary': settings.ringCaptchaMessages.sendPinCodeToPhoneLabel,
            'error.session_expired': '',
            'help:': '',
            'check.summary': '',
            'check.help': '',
            'error.invalid_number_length': settings.ringCaptchaMessages.incorrectPhoneNumber,
            'error.invalid_number': settings.ringCaptchaMessages.incorrectPhoneNumber,
            'error.invalid_pin_code': settings.ringCaptchaMessages.invalidPinCode,
            'check.error.invalid_pin_code': settings.ringCaptchaMessages.invalidPinCode,
        },
    };

    return {
        require: '^?ngModel',
        restrict: 'A',
        scope: {
            phoneNumber: '=',
            deliveryOptions: '@?',
            onVerification: '&',
            onSessionTimeOut: '&',
            onExceedMaximumRetries: '&',
        },
        template: require('./mobile-phone-verification.directive.html').trim(),
        link: (scope) => {
            resourceInjector.injectScript(settings.ringCaptchaMessages.ringCaptchaWidgetJsPath).then(() => {

                // TODO Use $timeout instead of setTimeout
                setTimeout(() => {
                    loadWidget(scope, settings);
                });
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/mobilephonevalidator/mobile-phone-verification.directive.js